import React from "react";

interface DetailFieldProps {
  label: string;
  labelWidth?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  labelWidth = "120px",
  children,
  style,
}) => (
  <div
    className="field is-horizontal my-1"
    style={{ borderBottom: "solid 1px lightgrey" }}
  >
    <dt
      className="field-label mr-2 has-text-left has-text-weight-bold"
      style={{ minWidth: labelWidth }}
    >
      {label}
    </dt>
    <dd className="field-body" style={style}>
      {children}
    </dd>
  </div>
);
